import { render, staticRenderFns } from "./CMSMailManager.vue?vue&type=template&id=56c19e3a"
import script from "./CMSMailManager.vue?vue&type=script&lang=js"
export * from "./CMSMailManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports